import parseArcaResponse from '../parseArcaResponse';
import { PasswordRequirementI } from './interfaces/PasswordRequirement';

interface PasswordRequirementResponseI {
	success?: boolean;
	data?: PasswordRequirementI;
}

/**
 * ¿Debe la persona de esta sesión establecer contraseña AHORA? Lo decide el backend en vivo
 * (`GET /auth/password-requirement`), no el JWT: el token se acuña una vez y no se entera de
 * lo que cambie después (el NIF que escribe el KYC, por ejemplo).
 *
 * 🔴 Lanza ante cualquier respuesta que no sea un éxito con `data`. comparsa responde HTTP 200
 * hasta para un 404 (`AllExceptionFilter`), así que un back que aún no tenga el endpoint
 * llega como `success: false`; y `parseArcaResponse` deja pasar un cuerpo ilegible como `{}`.
 * Quien llama (`usePasswordRequirement`) traduce el error a «entra sin modal».
 */
const getPasswordRequirement = async (token: string): Promise<PasswordRequirementI> => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/auth/password-requirement`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`
		}
	});

	const body = await parseArcaResponse<PasswordRequirementResponseI>(response);

	if (body.success !== true || !body.data) {
		throw new Error(`Respuesta inesperada de password-requirement (HTTP ${response.status})`);
	}

	return body.data;
};

export default getPasswordRequirement;
